var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTrustly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1250 416",
    style: {
      enableBackground: "new 0 0 1250 416"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C5194;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.4,291.8V156.7h-48.5v-32.1h131.9v32.1h-48.5v135.1H458.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M536.3,291.8V170.5h32.1v19.2c7.6-16.3,17.4-19.2,27.9-19.2h12.4V203h-10.5c-15.1,0-28.6,8.7-28.6,35.3v53.6 H536.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.8,247.4v-76.9H657v69.4c0,14.2,6.9,24.7,21.1,24.7c13.7,0,22.4-10.5,22.4-24.5v-69.6h33.2v121.4h-31.6 v-15.3c-8,12.1-19.9,18.1-35,18.1C640.5,294.6,623.8,276.3,623.8,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747.9,257.7l28.9-6.6c1.4,9.4,8.9,16.5,23.4,16.5c11.2,0,17.4-4.6,17.4-10.3c0-4.6-2.5-8-14-10.5l-19-4.1 c-24.3-5.3-34.6-16.5-34.6-36.9c0-20.8,17.2-37.6,49.5-37.6c34.3,0,48.1,20.6,49.5,34.1l-29.1,6.4c-1.4-7.1-6.6-14.9-21.1-14.9 c-9.2,0-16,4.1-16,10.1c0,5,3.4,7.8,9.4,9.2l27.7,6.4c21.1,4.8,30.9,17.4,30.9,35.3c0,19.2-15.3,39.4-50.4,39.4 C761.8,294.1,749.2,271,747.9,257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M914.6,291.8c-21.5,0-35.9-11.9-35.9-35.5v-56.8h-20.4v-29.1h20.4v-27l33.2-9.6v36.6h24.5v29.1h-24.5v50.8 c0,8.9,4.6,12.4,13.5,12.4h12.8v29.1H914.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M956.2,291.8V124.7h33.2v167.2H956.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1089.5,170.5h35.5l-50.6,164.9h-35.5l14-43.5h-18.3l-33.4-121.4h35.5l25,93.9L1089.5,170.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "125,197.9 202.9,197.9 202.9,135.7 265.1,197.9 202.9,260 202.9,291.8 278.4,291.8 278.4,197.9  347.7,197.9 347.7,124.7 125,124.7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrustly);
export default __webpack_public_path__ + "static/media/logo_trustly.caecdd61c89ad10a6185cb28df719d73.svg";
export { ForwardRef as ReactComponent };